var _style, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "pay_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 1024 1024"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#35a4dd",
    strokeWidth: 65,
    d: "M41.6 189.7h940.9v644.7H41.6z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#35a4dd",
    strokeWidth: 120,
    d: "M41.6 360.3h940.8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 801.3,
    cy: 659.6,
    r: 69.7,
    stroke: "#f9af17",
    strokeWidth: 65
  }))));
}

export default SvgPay;